<template>
    <div>
        <el-table :data="detail.toUser">

            <el-table-column label="用户名" prop='internalUserid'></el-table-column>

            <el-table-column label="真实姓名" prop='name'></el-table-column>
            
            <el-table-column label="角色名称" prop='position'></el-table-column>
            
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>

